export default "__VITE_ASSET__CLBAnJTi__"